import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "48px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
    gap: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "16px",
    maxWidth: "none",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  fontFamily: "Georgia",
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  lineHeight: "48px",
  letterSpacing: "0.06px",
  textTransform: "unset",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
    maxWidth: "700px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "24px",
    fontWeight: "400",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
    textAlign: "center",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: props?.$bold ? 600 : 400,
  lineHeight: "36px",
  letterSpacing: "0.036px",
  textAlign: "center",
  maxWidth: "1005px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "unset",
    fontSize: "20px",
    lineHeight: "30px",
    letterSpacing: "0.03px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "16px",
    lineHeight: "22.4px",
    textAlign: "center",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "48px",
  padding: "0px",
  background: "transparent",
  justifyItems: "center",
  alignItems: "stretch",
  maxWidth: "1200px",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
    justifyContent: "center",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "200px",
  width: "200px",

  [props.theme.breakpoints.down("lg")]: {
    height: "120px",
    width: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: props.type == "desc" ? "rgba(0, 0, 0, 0.87)" : "#000",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "20px" : "24px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 600,
  lineHeight: props.type == "desc" ? "30px" : "36px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "unset",

  ...(props.type == "small_desc" && {
    color: " rgba(0, 0, 0, 0.60)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    alignSelf: "stretch",
    letterSpacing: "0.15px",
  }),

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "12px" : "16px",
    lineHeight: props.type == "desc" ? "18px" : "24px",
    letterSpacing: props.type == "desc" ? "0.15px" : "0.024px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "24px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",

    ...(props.type == "small_desc" && {
      fontSize: "12px",
      lineHeight: "18px",
      letterSpacing: "unset",
    }),
  },
}));

export const LineBreak = styling("div")((props) => ({
  height: "1px",
  width: "50px",
  backgroundColor: "#000",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    // width: "100%",
    // height: "1px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const ExtraText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  textAlign: "center",
  maxWidth: "1005px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "700px",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "14px",
    lineHeight: "22.4px",
    textAlign: "center",
  },
}));
